import { render, staticRenderFns } from "./ShareAgendaItemDialog.vue?vue&type=template&id=09552ce6"
import script from "./ShareAgendaItemDialog.vue?vue&type=script&lang=js"
export * from "./ShareAgendaItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports